import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";
import ImageLoader from "../../../Common/ImageLoader";
import AddMemberIcon from "../../../icons/add-member.icon";
import styles from "./distributor-header.module.scss";

const DistributorHeader = ({ distributorData }) => {
  const navigate = useNavigate(); 

  if (!distributorData) {
    return null;
  }

  // For now, using a placeholder plan name. This should come from distributorData when available
  const planName = "Disti Plan 1";

  return ( 
    <>
      {/* Breadcrumb Navigation */}
      <div className={styles.breadcrumbContainer}>
        <div className={styles.breadcrumbContent}>
          <div 
            className={styles.backButton}
            onClick={() => {
              navigate(ROUTE_PATHS.subscriptionPortalPages.distributors);
            }}
          >
            <img
              src="/images/attack-surface/back-icon.svg"
              alt=""
              className={styles.backIcon}
            />
            <span className={styles.backText}>Back</span>
          </div>
          <span className={styles.breadcrumbSeparator}>Distributors</span>
          <span className={styles.breadcrumbDivider}>&nbsp; &nbsp;/&nbsp;&nbsp;</span>
          <span className={styles.breadcrumbCurrent}>
            {distributorData.company.name}
          </span>
        </div>
      </div>

      {/* Header Content */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <ImageLoader
            src={distributorData.company.avatar}
            alt={`${distributorData.company.name} avatar`}
            className={styles.avatar}
            noImageComponent={
              <div className={styles.avatarPlaceholder}>
                {distributorData.company.initial}
              </div>
            }
          />

          <div className={styles.infoContainer}>
            <div className={styles.infoContent}>
              <div className={styles.titleRow}>
                <h1 className={styles.title}>
                  {distributorData.company.name}
                </h1>
                <div className={styles.planBadge}>
                  <span className={styles.planBadgeText}>
                    {planName}
                  </span>
                </div>
              </div>

              <div className={styles.contactRow}>
                <AddMemberIcon className={styles.contactIcon} />
                <p className={styles.contactText}>
                  <span className={styles.contactLabel}>Primary Contact:</span>
                  <span className={styles.contactName}>
                    {" "}
                    {distributorData.contact.name}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default DistributorHeader;
